export const ContactsInitialVariables = {
	contactDetails: null,
	isContactDetailsLoading: true,
	isAddContactLoading: false,

};
